<div class="carprice">
  <div class="inner_carprice_contents flex_layout">
    <div class="inquiry_box flex_layout">
      <a href="{{ appUrl }}/inquiry?car_id={{ car.id }}" class="inquirybtn btn_mail">
        <div class="inquiry_icon"><img src="assets/img/inquiry_mail.png" width="40" alt=""></div>
        <div class="inquiry_label">{{ lang | i18nSelect: strings.carDetail.inquiryButtonLabel }}</div>
      </a>
    </div>
    <div class="carprice_box" *ngIf="!car.sold">
      <div class="carprice fixedprice flex_layout" [ngClass]="{ 'discountcarprice': car.previousPrice}">
        <div class="pricelabel" *ngIf="lang==='ja'">車両価格</div>
        <div *ngIf="car.previousPrice" class="pricedata">
          <span class="regularprice"><span class="previous_price" [innerHTML]="car.previousPrice | priceFormat: ' pricenum': 'pricecur'"></span></span>
          <span class="discountprice"><span class="current_price" [innerHTML]="car.price | priceFormat: ' pricenum': 'pricecur'"></span></span>
        </div>
        <div *ngIf="!car.previousPrice" class="pricedata">
          <span class="current_price" [innerHTML]="car.price | priceFormat: ' pricenum': 'pricecur'"></span>
        </div>
      </div>
      <div class="total_price">( {{ lang | i18nSelect: strings.carPrice.totalPricePrefix }} <span class="total_price_value" [innerHTML]="car.totalPrice | priceFormat: ' pricenum': 'pricecur'"></span> <span class="price_label_suffix">{{ lang | i18nSelect: strings.carPrice.totalPriceSuffix }}</span> )</div>
    </div>
  </div>
</div>
